import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import userLocaleLocalStorage from 'shared/userLocale/userLocaleLocalStorage';

const userLang = 'es';
const defaultLocale = userLang.substring(0, 2);

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: userLocaleLocalStorage.get() || defaultLocale,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
